import React from 'react';
import cn from 'classnames';
import i18n from 'i18next';
import { SunSides } from '@websky/graphql';
import { getDurationString } from '../../../../../Results/utils';
import { SunIcon, TimeIcon } from '../../../../../Icons';
// TODO: move to /entities/aircraft/ui or /entities/flight/ui
import AircraftPopup from '../../../../../AircraftPopup';
import AircraftLivery from '../../../../../AircraftLivery';
import Amenities from '../../../../../Amenities';
import { AirplaneName, AirplaneOption } from './ui';
import { useIsMobile } from '../../../../../utils';
import { useTheme } from '../../../../../theme';
const labels = {
    [SunSides.LeftSide]: i18n.t('SeatMap:90% on the left side'),
    [SunSides.RightSide]: i18n.t('SeatMap:90% on the right side'),
    [SunSides.NoneSide]: ''
};
const FlightDetails = ({ className, sunSide, segmentInfo, amenities, isReturnFlight }) => {
    var _a, _b, _c;
    const { FlightDetails: css } = useTheme('Entities').SeatMap;
    const isMobile = useIsMobile();
    const durationStr = segmentInfo.duration ? getDurationString(segmentInfo.duration) : null;
    const isNoneSide = sunSide === SunSides.NoneSide;
    return (React.createElement("div", { className: cn(css.wrapper, className, {
            [css.noInfo]: !((_a = segmentInfo.aircraft) === null || _a === void 0 ? void 0 : _a.name) && !((_b = segmentInfo.aircraft) === null || _b === void 0 ? void 0 : _b.icon)
        }) },
        segmentInfo.departure && segmentInfo.arrival && isMobile && (React.createElement("div", { className: css.segment },
            segmentInfo.departure.airport.city.name,
            ' — ',
            segmentInfo.arrival.airport.city.name)),
        React.createElement("div", { className: css.top },
            React.createElement(AircraftLivery, { aircraft: segmentInfo.aircraft, className: css.image, isReturnFlight: isReturnFlight }),
            React.createElement("div", { className: css.info__wrapper },
                segmentInfo.aircraft && (React.createElement(AircraftPopup, { id: segmentInfo.aircraft.id, operatingIata: (_c = segmentInfo.operatingAirline) === null || _c === void 0 ? void 0 : _c.iata, name: segmentInfo.aircraft.name, renderButton: onClick => (React.createElement(AirplaneName, { text: segmentInfo.aircraft.name, onClick: onClick })) })),
                !!(amenities === null || amenities === void 0 ? void 0 : amenities.length) && React.createElement(Amenities, { className: css.amenities, amenities: amenities }))),
        React.createElement("div", { className: cn(css.details, {
                [css.details_one]: isNoneSide
            }) },
            durationStr && React.createElement(AirplaneOption, { text: durationStr, icon: TimeIcon }),
            !isNoneSide && React.createElement(AirplaneOption, { text: labels[sunSide], icon: SunIcon }))));
};
export default FlightDetails;
